export default "__VITE_ASSET__2719704f__"